import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import './style.scss';
import Icon from '../Icon';

const DrawerLink = ({ ...props }) => {
	const { hidden = false, disabled = false, spaceAbove = false, className = '', title, to, href, icon } = props;

	if (hidden) {
		return null;
	}

	const classes = `drawer-link${disabled ? ' inactive' : ''} ${spaceAbove ? ' space-above' : ''}${className}`.trim();

	const iconElement = icon ? <Icon>{icon}</Icon> : null;

	if (disabled) {
		return (
			<div className={classes}>
				{iconElement}
				{title}
			</div>
		);
	}

	if (to) {
		return (
			<NavLink {...props} className={classes}>
				{iconElement}
				{title}
			</NavLink>
		);
	}

	return (
		<a href={href} {...props} className={classes}>
			{iconElement}
			{title}
		</a>
	);
};

DrawerLink.propTypes = {
	title: PropTypes.node.isRequired,
	to: PropTypes.string,
	exact: PropTypes.bool,
	hidden: PropTypes.bool,
	disabled: PropTypes.bool,
	onClick: PropTypes.func,
	icon: PropTypes.string,
	className: PropTypes.string,
	spaceAbove: PropTypes.bool
};

export default DrawerLink;
